import { BarsLoadingIndicator } from 'components/common/barsLoadingIndicator';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
function PleaseWaitForm({ text, isLoading = false }) {
    const Lang = useSelector((state) => state.miniBookingWidget?.data?.Lang);
    return (
        <div className="ab-final-step-wrapper">
            <p className="ab-book-confrm-text">
                {Lang?.yourBookingIsConfirmed}!
            </p>
            {isLoading && (
                <BarsLoadingIndicator
                    classes="ab-bars-loading-indicator--light-gray"
                    size={25}
                    style={{ marginTop: '25px' }}
                />
            )}
            <div
                className="ab-book-confrm-main-text"
                style={{ marginTop: '15px' }}
            >
                {text}
            </div>
        </div>
    );
}
PleaseWaitForm.propTypes = {
    isLoading: PropTypes.bool,
    text: PropTypes.string,
};

export default PleaseWaitForm;
